var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      var formState = getFormState(state);
      return getIn(formState, form + '.submitFailed') || false;
    };
  };
};

export default createHasSubmitFailed;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/selectors/hasSubmitFailed.js
// module id = 1031
// module chunks = 0